/**
 * THE LIVE MOON FOUNDRY INSTANCE — a leaf, because it is mutable STATE.
 *
 * `window.foundry` was not a module namespace like the others. It is a slot with
 * a lifecycle: `foundry.js` puts a `new MoonFoundry()` in it, `foundry-surface.js`
 * re-points it when it mounts, and both clear it to null on teardown. An ESM
 * export cannot be reassigned from another module, so exporting the instance
 * would have frozen the first value in place and quietly broken teardown.
 *
 * A getter/setter pair is the honest translation. Only foundry.js and
 * foundry-surface.js ever touched the global — no other client module read it —
 * so this stays a two-party arrangement rather than becoming a new global by
 * another name.
 */

/** @type {any} */
let current = null;

/** The live instance, or null when nothing is mounted. */
export function getFoundry() {
    return current;
}

/**
 * Point the slot at an instance, or clear it with null.
 * @param {any} instance
 */
export function setFoundry(instance) {
    current = instance ?? null;
}

/**
 * Clear the slot only if it still holds `instance`.
 *
 * Both teardown paths were written as `if (window.foundry === x) window.foundry = null`
 * — the check matters, because a newer mount may already own the slot and must
 * not be cleared by an older instance unwinding.
 * @param {any} instance
 */
export function clearFoundryIf(instance) {
    if (current === instance) current = null;
}
